import script from "./SpecimensCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecimensCard.vue?vue&type=script&setup=true&lang=js"

import "./SpecimensCard.vue?vue&type=style&index=0&id=aafdfe2e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aafdfe2e"]])

export default __exports__